export default __webpack_public_path__ + "static/media/img (2).5f75ffad.jpg";